import script from "./bookDemo.vue?vue&type=script&setup=true&lang=js"
export * from "./bookDemo.vue?vue&type=script&setup=true&lang=js"

import "./bookDemo.vue?vue&type=style&index=0&id=cf34bf00&scoped=true&lang=css"

import exportComponent from "/mnt/extra-storage/rentalkenya_vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cf34bf00"]])

export default __exports__